import { render } from "./NewButton.vue?vue&type=template&id=5d085c7a"
const script = {}

import "./NewButton.vue?vue&type=style&index=0&id=5d085c7a&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__